import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
const Steps = ({ dynamicList = [] }) => {
    const theme = useTheme();
    const isMobile = !useMediaQuery(theme.breakpoints.up("md"));
    return (_jsx(Stack, { children: dynamicList.map((step, index) => {
            const position = index + 1;
            const isLastChildren = position === dynamicList.length;
            return (_jsxs(Stack, { direction: "row", sx: {
                    gap: { xs: 3, md: 7 },
                    minHeight: isLastChildren ? "auto" : 144,
                    maxWidth: 900,
                }, children: [_jsxs(Stack, { sx: { position: "relative" }, children: [_jsx(Stack, { sx: {
                                    width: { xs: 48, md: 56 },
                                    height: { xs: 48, md: 56 },
                                    borderTop: "3px solid",
                                    borderColor: step.borderColor,
                                    backgroundColor: "background.paper",
                                    outline: "1px solid",
                                    outlineColor: "border.default",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }, children: _jsx(Typography, { sx: {
                                        color: "text.primary",
                                        fontWeight: 700,
                                        fontSize: { xs: 16, md: 20 },
                                        lineHeight: "100%",
                                    }, children: position < 10 ? `0${position}` : position }) }), !isLastChildren && (_jsx(Divider, { style: {
                                    position: "absolute",
                                    left: "50%",
                                    top: isMobile ? 48 : 56,
                                    height: isMobile
                                        ? "calc(100% - 48px)"
                                        : "calc(100% - 56px)",
                                    width: 1,
                                } }))] }), _jsxs(Stack, { sx: {
                            width: "100%",
                            p: {
                                xs: `4px 0px ${isLastChildren ? 0 : 28}px 0px`,
                                md: `4px 0px ${isLastChildren ? 0 : 40}px 0px`,
                            },
                            gap: 1.5,
                        }, children: [_jsx(Typography, { component: "h3", variant: "h5", sx: {
                                    color: "text.primary",
                                }, children: step.title }), _jsx(Typography, { variant: "body2", sx: {
                                    color: "text.primary",
                                }, children: step.description })] })] }, step.title));
        }) }));
};
export default Steps;
